import { environment } from '../../../environments/environment';
/** API_URLS */
export const API_URLS = {
    ONELOGIN_ROUTES: {
        UNAUTHORIZED: '/meinvodafone/account/nicht_erlaubt',
    },
    LOGIN: {
        GET: environment.baseUrlNil + '/enterprise-resources/core/bss/order-nil/order/sales-orders/order-details',
        GET_TARIFF_NAME: environment.baseUrlNil + '/vluxgate/hardware/mobile/tariffName/{tarifCode}',
        GET_IMAGES_FROM_VLUX: environment.baseUrlNil + '/vluxgate/hardware/mobile/imageLink/{articleNumber}',
    },

    HARDWARE: {
        GET_MOBILE_BY_TARIFF: environment.baseUrlNil + '/vluxgate/hardware/mobile/byTarif/{tarifCode}',
        GET_AVAILABLE_DEVICES_BY_TARIFF: environment.baseUrlNil + '/vluxgate/hardware/mobile/byTarif/{tarifCode}',
        GET_HARDWAR_DETAILS: environment.baseUrlNil + '/vluxgate/hardware/mobile/{hardwareId}/byTarif/{tarifCode}',
    },
    ORDER_DETAILS: {
        DOWNLOAD_ORDER_DETAILS: environment.baseUrlNil + '/enterprise-resources/core/bss/order-nil/order/sales-orders/shipping-label',
        CHANGE_ORDER: environment.baseUrlNil + '/enterprise-resources/core/bss/order-nil/order/sales-orders/order-change',
    },
    RETURN_HW_LABEL: {
        GET_RETURN_HW: {
                url: environment.baseUrlDxlProd  + '/public/v2/hardwareReturnLabel',
                st: environment.baseUrlDxl + '/tobi/v1/hardwareReturnLabel',
                test: environment.baseUrlDxlTestFullPath + '/tobi/v1/hardwareReturnLabel',
                preprod: environment.baseUrlDxlPreProdFullPath + '/public/v2/hardwareReturnLabel',
                api_name: 'hardwareReturnLabel',
            },
    },
    TERMINATE_CONTRACT: {
        TERMINATE_COMTRACT_HW: {
            url: environment.baseUrlDxlProd + '/public/v2/terminateContractWithHardware',
            st: environment.baseUrlDxl + '/public/v2/terminateContractWithHardware',
            test: environment.baseUrlDxlTestFullPath + '/public/v2/terminateContractWithHardware',
            preprod: environment.baseUrlDxlPreProdFullPath + '/public/v2/terminateContractWithHardware',
            api_name: 'terminateContract-HW-POST',
          },
    },
};
